module.exports = __webpack_public_path__ + "img/marker-sa2-h-background.6935260d.gif";